module.exports = __webpack_public_path__ + "eae437a08b7e4feb79d1b40f91f04fcf.svg";